// extracted by mini-css-extract-plugin
export var mapMarkerSelected = "StorePins-module--map-marker-selected--2d23a";